module.exports = __webpack_public_path__ + "img/lens-174-minus-08.698cee76.png";